import { Input as AntdInput, Form, Typography } from 'antd'
import { t } from 'i18next'
import { memo } from 'react'
import styled from 'styled-components'
const StyledInput = styled(AntdInput)`
  width: 100%;
`

const FlowCytometryReviewAnalysisConfigurationModalMappingStep = memo(() => {
  const [form] = Form.useForm()
  const patientId = Form.useWatch('patientId', form)
  const visitCode = Form.useWatch('visitCode', form)
  const tubeName = Form.useWatch('tubeName', form)
  const cytometer = Form.useWatch('cytometer', form)
  const plate = Form.useWatch('plate', form)
  const exportTime = Form.useWatch('exportTime', form)

  return (
    <>
      <Typography.Text strong>
        {t('reviewAnalysisConfigurationModal.steps.mapping.description')}
      </Typography.Text>
      <Form.Item label={t('reviewAnalysisConfigurationModal.steps.mapping.fields.patientIdPrefix')}>
        <StyledInput
          placeholder={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.placeholder')
          }
          prefix={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.patientIdPrefix')
          }
          value={patientId}
          variant="filled"
        />
      </Form.Item>
      <Form.Item label={t('reviewAnalysisConfigurationModal.steps.mapping.fields.visitCodePrefix')}>
        <StyledInput
          placeholder={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.placeholder')
          }
          prefix={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.visitCodePrefix')
          }
          value={visitCode}
          variant="filled"
        />
      </Form.Item><Form.Item label="Mapping Name(s)">
        <StyledInput
          placeholder={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.placeholder')
          }
          prefix={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.tubeNamePrefix')
          }
          value={tubeName}
          variant="filled"
        />
      </Form.Item><Form.Item label="Mapping Name(s)">
        <StyledInput
          placeholder={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.placeholder')
          }
          prefix={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.cytometerPrefix')
          }
          value={cytometer}
          variant="filled"
        />
      </Form.Item>
      <Form.Item label="Mapping Name(s)">
        <StyledInput
          placeholder={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.placeholder')
          }
          prefix={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.platePrefix')
          }
          value={plate}
          variant="filled"
        />
      </Form.Item>
      <Form.Item label="Mapping Name(s)">
        <StyledInput
          placeholder={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.placeholder')
          }
          prefix={
            t('reviewAnalysisConfigurationModal.steps.mapping.fields.exportTimePrefix')
          }
          value={exportTime}
          variant="filled"
        />
      </Form.Item>
    </>
  )
})
export default FlowCytometryReviewAnalysisConfigurationModalMappingStep
